import { ClickOutsideDirective } from './click-outside.directive';
import { OnlyNumberDirective } from './only-number.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { EmailListValidatorDirective } from './email-list-validatior.directive';
import { DisableFeatureDirective } from './disable-feature.directive';
import { AutofocusDirective } from './autofocus.directive';
import { HoverClassDirective } from './hover-class.dirctive';

const components = [
  ClickOutsideDirective, OnlyNumberDirective,
  EmailListValidatorDirective, DisableFeatureDirective, AutofocusDirective, HoverClassDirective
];

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: components,
  providers: [],
  exports: [...components],
  schemas: []
})
export class CommonDirectivesModule {
}
